export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const getView = async (searchText) => {
    try {
        const result = await get('view');

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const insertView = async (data) => {
    try {
        const result = await post('view', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};